import { useQuery } from "@apollo/client";

import { GqlSettingsResearchTypeGetAllParams } from "~/__generated__";
import useCacheFilterOptions from "~/modules/app/hooks/useCacheFilterOptions";

import { SettingsResearchTypeListRoute_GetAllDocument } from "../queries.generated";

export default function useSettingsResearchTypeListRoute_GetAll(params: GqlSettingsResearchTypeGetAllParams) {
    const { data, loading, error } = useQuery(SettingsResearchTypeListRoute_GetAllDocument, {
        variables: { params: params },
    });

    const queryInfo = data?.settingsResearchTypeGetAll.queryInfo;
    const [, total] = useCacheFilterOptions(null, queryInfo?.paginationOption.total);
    return {
        loading,
        error,
        total: total,
        researchTypes: data?.settingsResearchTypeGetAll.data,
    };
}
